<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main style="padding: 0">
          <nav-bar style="padding-left: 20px"></nav-bar>
          <template>
            <iframe
              :src="url"
              id="iframe"
              scrolling="no"
              frameborder="0"
            ></iframe>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>
    
    <script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";

export default {
  name: "index",

  data() {
    return {
      url: "",
    };
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },
  mounted() {
    this.url = Globals.SYAIDiagnosisUrl + "&&language=" + this.activeLang;
    /**
     * iframe-宽高自适应显示
     */
    function changeIframe() {
      const iframe = document.getElementById("iframe");
      const deviceWidth = document.documentElement.clientWidth;
      const deviceHeight = document.documentElement.clientHeight;
      iframe.style.width = Number(deviceWidth) - 98 + "px"; //数字是页面布局宽度差值
      iframe.style.height = Number(deviceHeight) - 102 + "px"; //数字是页面布局高度差
    }

    changeIframe();

    window.onresize = function () {
      changeIframe();
    };
  },
};
</script>
    
     
    